import 'content.scss';
import './components/_lang';
import './components/_fontSize';
import './components/_lightbox';

$(document).ready(function() {



    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function() {
            $(this).remove();
        });
    }

    imagesLoaded("html, body", function() {
        removeLoading();
    });
});